

function ViewportsResizeBehaviour() {


    return {
        resize: () => {
        },
        clear: () => {
        }
    };
}

module.exports = ViewportsResizeBehaviour;


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/behaviors/NoneViewportsResizeBehaviour.js